import { render } from "./EndorsementsEng.vue?vue&type=template&id=419b875a"
import script from "./EndorsementsEng.vue?vue&type=script&lang=js"
export * from "./EndorsementsEng.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__